<template>
  <div>
    <v-card
      class="pa-7 transition d-flex flex-column align-center justify-space-center"
      color="gray10"
    >
      <span class="font-Medium-16">{{
        $t("accountPage.security.twoFactorAuth.modals.activeGoogle.step3.title")
      }}</span>
      <p class="mt-4">
        {{
          $t(
            "accountPage.security.twoFactorAuth.modals.activeGoogle.step3.description"
          )
        }}
      </p>

      <v-alert
        text
        class=" px-3 py-3"
        color="warning"
        icon="$warning"
        rounded="lg"
      >
        <span class="font-Regular-14">
          {{
            $t(
              "accountPage.security.twoFactorAuth.modals.activeGoogle.step3.warning"
            )
          }}
        </span>
      </v-alert>

      <form autocomplete="off" class="my-10" style="width: 300px;">
        <v-row align="center" class="flex-column">
          <input
            type="text"
            pattern="^\d{1,6}$"
            title=""
            maxlength="6"
            class="input field gray1--text code "
            v-model="authenticatorCode"
            :placeholder="
              $t(
                'accountPage.security.twoFactorAuth.modals.activeGoogle.step3.googleLabel'
              )
            "
            autofocus
            autocomplete="off"
          />
        </v-row>
        <span v-if="googleCodeError" class="font-Regular-12 error--text">
          {{
            $t(
              "accountPage.security.twoFactorAuth.modals.activeGoogle.step3.emptyGoogleAuth"
            )
          }}
        </span>

        <v-row align="center" class="flex-column mt-6">
          <!--                      <div class="font-Regular-12 mb-4">-->
          <!--                        {{$t("accountPage.security.twoFactorAuth.modals.activeGoogle.step4.passwordTitle")}}-->
          <!--                      </div>-->
          <v-text-field
            hide-details
            style="width: 100%;"
            :label="
              $t(
                'accountPage.security.twoFactorAuth.modals.activeGoogle.step3.passwordLabel'
              )
            "
            :type="googlePasswordType"
            @focus="googlePasswordType = 'password'"
            filled
            background-color="var(--v-field-base)"
            class="custom-form-control login-form-control password-form-control"
            v-model="password"
          >
            <template v-slot:append>
              <div
                @click="toggleShowPassword"
                class="show-password-append"
                style="cursor: pointer;"
              >
                <v-icon size="24" v-if="showPassword" clr="var(--v-gray2-base)"
                  >$eyeShow</v-icon
                >
                <v-icon size="24" clr="var(--v-gray2-base)" v-else
                  >$eyeHidden</v-icon
                >
              </div>
            </template>
          </v-text-field>
        </v-row>
        <span v-if="googlePasswordError" class="font-Regular-12 error--text">
          {{
            $t(
              "accountPage.security.twoFactorAuth.modals.activeGoogle.step3.emptyPassword"
            )
          }}
        </span>
      </form>
    </v-card>

    <v-btn
      :loading="loading"
      block
      color="primary"
      class="mt-15 py-6"
      @click="verifyGoogle"
    >
      {{
        $t("accountPage.security.twoFactorAuth.modals.activeGoogle.continue")
      }}
    </v-btn>
  </div>
</template>

<script>
import $enDigits from "@/mixins/enDigits";
import { OtpService, UserService } from "@/services";

export default {
  mixins: [$enDigits],
  data() {
    return {
      authenticatorCode: "",
      googleCodeError: false,
      googlePasswordType: "text",
      showPassword: false,
      googlePasswordError: false,
      loading: false
    };
  },

  computed: {
    isGoogleCodeValid() {
      if (this.authenticatorCode) {
        const phoneRegex = /^\d{1,6}$/;
        return phoneRegex.test(this.authenticatorCode);
      }
      return true;
    }
  },
  watch: {
    authenticatorCode(newValue, oldValue) {
      const value = this.$enDigits(newValue);
      this.authenticatorCode = value;
      const regex = /^\d+$/;
      const isCodeValid = regex.test(value);
      if (newValue) {
        if (!isCodeValid) {
          this.authenticatorCode = this.$enDigits(oldValue);
        }
      }
    }
  },

  methods: {
    verifyGoogle() {
      this.googleCodeError = false;
      this.googlePasswordError = false;

      if (!this.authenticatorCode) {
        this.googleCodeError = true;
      }

      if (!this.password) {
        this.googlePasswordError = true;
      }

      if (this.isGoogleCodeValid && this.password) {
        this.loading = true;
        OtpService.verify("google2fa", this.authenticatorCode, this.password)
          .then(res => {
            this.getUserInfo();
            this.getUserInfoVerify();
            this.authModal = false;
            this.$toast.success(res.data.message);
            this.authenticatorCode = "";
            this.googlePasswordType = "text";
            this.$emit("finish");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
      this.googlePasswordType =
        this.googlePasswordType === "password" ? "text" : "password";
    },

    getUserInfoVerify() {
      UserService.getVerifyInfo().then(res => {
        this.setUserVerifyInfo(res.data.data);
      });
    },
    getUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.input {
  width: 100%;
  //max-width: 328px;
  height: 56px;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  direction: ltr;
  font-weight: bold;
  letter-spacing: 16px;
  background: #00000003;
  text-align: center;

  &:hover {
    background: #f7f7f7;
    border: 1px solid #0000003d;
  }

  &:focus {
    outline: none;
    border: blue 1px solid;
  }

  &::placeholder {
    font-weight: normal;
    letter-spacing: 0;
  }

  &_name {
    position: absolute;
    padding-top: 15px;
    padding-right: 17px;
  }

  &_unit {
    position: absolute;
    margin-top: 15px;
    left: 32px;
  }

  &_validation {
    width: 100%;
    height: 32px;
    display: block;
    color: #ec484a;
    padding: 0 12px;

    &_on {
      font-size: 11px;
      opacity: 1;
      transition: 0.2s ease-in;
    }

    &_off {
      font-size: 11px;
      opacity: 0;
    }
  }
}

.code {
  background: #00000003;

  &:focus {
    outline: none;
    background: #00000003 !important;
    border: var(--v-primary-base) 1px solid !important;
  }

  &:hover {
    outline: none;
    background: #f7f7f7;
    border: 1px solid #0000003d;
  }

  &:invalid {
    border: 1px solid red;
  }
}
</style>
